// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2hcTc","content":"Consent_content__3mKsC","footer":"Consent_footer__29f0z"};